<template>
  <reservationList></reservationList>
</template>

<script>
import reservationList from "@/components/reservationList";
import Manage from "@/components/Manage.vue"
import headTop from "@/components/headTop.vue"

export default {
  name: "ReservationView",
  components: {
    reservationList,
    Manage,
    headTop
  },
}
</script>

<style scoped>

</style>